function createEditorService() {
    let editor;
    const isEditor = () => {
        return editor;
    };
    const setEditor = (value) => {
        editor = value;
    };
    return {
        isEditor,
        setEditor,
    };
}
const EditorService = createEditorService();
export { EditorService, };
//# sourceMappingURL=editor-service.js.map